<template>
  <div class="comm_scrInput_wrap">
    <div>
      <sui-text-field
        ref="knoxUserName"
        v-model="knox.userName"
        :disabled="disabled"
        :fixedIcon="fixedIcon"
        :maxlength="maxlength"
        @keyup.enter="onEmpClick"
        @clear-input="reset"
        @focus="focus"
      />
    </div>
    <sui-button
      type="button"
      class="comm_btn_InputScr"
      @click="onEmpClick"
    />
  </div>
</template>
<script>
export default {
  name: 'CmpEmpMultiSelect',
  props: {
    selectedKnoxUser: {
      type: Object,
      default() {
        return {
          userName: '',
          epId: '',
          epNo: '',
          knoxId: '',
          email: '',
          cpnyCd: '',
          cpnyNm: '',
          cpnyEnNm: '',
          deptId: '',
          deptNm: '',
          deptEnNm: '',
          crlvCd: '',
          title: '',
          titlename: '',
          cp: '',
          pbLcIdYn: '',
          usrRealUseYn: '',
          usrTypeCd: '',
          irsdSttCd: '',
          dsplLngId: '',
          extrSysUsrYn: '',
          extrCompId: '',
          usrCntn: '',
          delYn: '',
          usrNm: '',
          usrGlblNm: '',
        };
      },
    },
    checkboxMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fixedIcon: {
      type: Boolean,
      default() {
        return false;
      },
    },
    maxlength: {
      type: String,
      default: '100',
    },
  },
  data() {
    return {
      knox: this.selectedKnoxUser,
      mode: this.checkboxMode,
    };
  },
  methods: {
    onEmpClick() {
      const knoxPopupMode = this.checkboxMode;
      let iptKnoxUserName = '';
      if (this.knox.userName !== '') {
        iptKnoxUserName = this.knox.userName;
      }

      utils.openLayerPopup('PGE_CMY_00002', this.onEmpPopupCallback, {
        pageInitialData: { iptKnoxUserName, knoxPopupMode },
        size: 'lg',
      });
    },
    onEmpPopupCallback(nodeData) {
      if (nodeData) {
        // console.log(nodeData);
        this.knox = nodeData;

        const knoxInfoData = [];
        let knoxNameArr = '';
        // console.log(nodeData);
        utils.forEach(nodeData, (value, key) => {
          knoxInfoData.push({
            userName: nodeData[key].cn,
            epId: nodeData[key].epid,
            epNo: nodeData[key].employeenumber,
            knoxId: nodeData[key].userid,
            email: nodeData[key].mail,
            cpnyCd: nodeData[key].eporganizationnumber,
            cpnyNm: nodeData[key].o,
            cpnyEnNm: nodeData[key].epenorganizationname,
            deptId: nodeData[key].departmentnumber,
            deptNm: nodeData[key].department,
            deptEnNm: nodeData[key].ependepartment,
            crlvCd: nodeData[key].eptitlenumber,
            title: nodeData[key].title,
            titlename: nodeData[key].eptitlename,
            cp: nodeData[key].mobile,
            pbLcIdYn: nodeData[key].epuserclassify,
            usrRealUseYn: 'Y',
            usrTypeCd: nodeData[key].employeetype,
            irsdSttCd: 'A',
            dsplLngId: nodeData[key].eppreferredlanguage,
            extrSysUsrYn: '',
            extrCompId: '',
            usrCntn: nodeData[key].description,
            delYn: 'N',
            usrGlblNm: nodeData[key].epencn,
          });
          knoxNameArr += `${nodeData[key].cn}${', '}`;
        });
        this.knox.userName = knoxNameArr;
        console.log(this.knox);
        this.$emit('selected', this.knox);
      }
    },
    focus() {
      this.$refs.knoxUserName.setFocus();
    },
    reset() {
      this.knox.userName = '';
      this.knox.epId = '';
      this.knox.epNo = '';
      this.knox.knoxId = '';
      this.knox.email = '';
      this.knox.cpnyCd = '';
      this.knox.cpnyNm = '';
      this.knox.cpnyEnNm = '';
      this.knox.deptId = '';
      this.knox.deptNm = '';
      this.knox.deptEnNm = '';
      this.knox.crlvCd = '';
      this.knox.title = '';
      this.knox.titlename = '';
      this.knox.cp = '';
      this.knox.pbLcIdYn = '';
      this.knox.usrRealUseYn = '';
      this.knox.usrTypeCd = '';
      this.knox.irsdSttCd = '';
      this.knox.dsplLngId = '';
      this.knox.extrSysUsrYn = '';
      this.knox.extrCompId = '';
      this.knox.usrCntn = '';
      this.knox.delYn = '';
      this.knox.usrGlblNm = '';
      this.$emit('selected', this.user);
    },
  },
};
</script>
<style scoped>
</style>
